module.exports = "../images/ear-falls-golf-and-country-club@2x.jpg?v=74bd964";